import { render } from "./FixedHeader.vue?vue&type=template&id=2e7447aa&scoped=true&ts=true"
import script from "./FixedHeader.vue?vue&type=script&lang=ts"
export * from "./FixedHeader.vue?vue&type=script&lang=ts"

import "./FixedHeader.vue?vue&type=style&index=0&id=2e7447aa&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7447aa"]])

export default __exports__